import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Calc from '@/components/Calc'
import Price from '@/components/Price'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/calc',
      name: 'Calc',
      component: Calc
    },
    {
      path: '/price',
      name: 'Price',
      component: Price
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js